import { fork } from 'redux-saga/effects';

import { RootSagaReturnType } from '~types/saga';
import watchGetProjectListing from './getProjectListing';
import ProjectGateway from '~apis/project';
import watchCreateNewProject from './createNewProject';
import watchGetProjectDetails from './getProjectDetails';
import watchEditProjectDetails from './editProjectDetails';
import watchGetProjectFilters from './getProjectFilter';

export default (api: ProjectGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchGetProjectListing, api);
        yield fork(watchCreateNewProject, api);
        yield fork(watchGetProjectDetails, api);
        yield fork(watchEditProjectDetails, api);
        yield fork(watchGetProjectFilters, api);
    }

    return {
        rootSaga,
    };
};
